import React from "react";
import Header2 from "../header2";

export default function Navbar(props) {
  return (
    <Header2 hclass={props.hclass} topbarClass={props.topbarClass}/>
  );
}
